import { Alert, Button, Col, Row, Spinner } from "react-bootstrap";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiCardRemoveOutline, mdiQuadcopter } from "@mdi/js";

import { useAuth } from "../../context/AuthContext";
import ApiService from "../../services/ApiService";

import Layout from "../../components/Layout";
import DroneCard from "../../components/DroneCard";

export default function Drones() {
	const navigate = useNavigate();
	const { cliente, handleLogout } = useAuth();
	const apiService = new ApiService(handleLogout);

	const { data, isLoading, isRefetching } = useQuery(["drones", cliente!.id, "cadastro"], () => fetchData());

	async function fetchData() {
		return await apiService.GetCadastroDronesCliente(cliente!.id);
	}

	return (
		<Layout>
			<h5 className="mt-3 mb-3 d-flex align-items-center fw-light flex-wrap gap-2" style={{ minHeight: 38 }}>
				<div className="d-flex align-items-center">
					<Icon path={mdiQuadcopter} size={1} className="me-1" /> Drones
					{isRefetching && <Spinner size="sm" className="ms-1" variant="secondary" />}
				</div>
				<div className="float-right ms-auto">
					<Button
						variant="air-blue"
						className="text-white"
						onClick={() => {
							navigate("/droneFormulario");
						}}
					>
						Cadastrar
					</Button>
				</div>
			</h5>

			<Row className="mb-4">
				{isLoading ? (
					<>
						{Array.from({ length: Number(process.env.REACT_APP_SKELETON_COUNT) }, (_, index) => {
							return (
								<Col md={12} key={index}>
									<DroneCard skeleton />
								</Col>
							);
						})}
					</>
				) : data?.Result !== 1 ? (
					<Col md={12}>
						<Alert variant="secondary" className="text-center">
							{data?.Message}
						</Alert>
					</Col>
				) : (
					<>
						{!data?.Data?.length ? (
							<Alert variant="light" className="text-center p-4 d-flex justify-content-center align-items-center">
								<Icon path={mdiCardRemoveOutline} size={1} className="me-2" />
								Nenhum registro encontrado
							</Alert>
						) : (
							data?.Data?.map((item, index) => {
								return (
									<Col md={12} key={index}>
										<DroneCard data={item} />
									</Col>
								);
							})
						)}
					</>
				)}
			</Row>
		</Layout>
	);
}
